import { Device } from '@/shared/enums';

const deviceType = {
  mobile: Device.MOBILE,
  desktop: Device.DESKTOP,
};

export default deviceType;
